module.exports = __webpack_public_path__ + "montserrat-light-webfont.e275041b67ba176dc676.woff2";


//////////////////
// WEBPACK FOOTER
// D:/Honda/Trunk/WizdomWebApp/Wizdom-Web-App/src/assets/fonts/montserrat-light-webfont.woff2
// module id = ../../../../../src/assets/fonts/montserrat-light-webfont.woff2
// module chunks = styles